import { render } from "./FundraisingCard.vue?vue&type=template&id=2c28bda9"
import script from "./FundraisingCard.vue?vue&type=script&lang=js"
export * from "./FundraisingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__